import { lazy } from "react";
import { PermissionGuard, PermissionEnum } from "@/modules/authentication";

const EndUsersLayout = lazy(() => import("../layouts"));
const EndUserDetailLayout = lazy(() => import("../layouts/EndUserDetailLayout"));
const AllUsers = lazy(() => import("./AllUsers"));
const OpenDhc = lazy(() => import("./OpenDhc"));
const Overview = lazy(() => import("./Overview"));
// const InviteAnswers = lazy(() => import("./InviteAnswers"));

const Routes = () => {
	const baseUrl = "/end-users";

	return [
		{
			path: baseUrl,
			element: (
				<PermissionGuard permission={PermissionEnum.EndusersRead}>
					<EndUsersLayout />
				</PermissionGuard>
			),
			children: [
				{
					path: "",
					element: <AllUsers />,
				},
				{
					path: "open-dhc",
					element: <OpenDhc />,
				},
			],
		},
		{
			path: `${baseUrl}/:endUserId`,
			element: (
				<PermissionGuard permission={PermissionEnum.EndusersRead}>
					<EndUserDetailLayout />
				</PermissionGuard>
			),
			children: [
				{
					path: "",
					element: <Overview />,
				},
				// {
				// 	path: "invite-answers",
				// 	element: <InviteAnswers />,
				// },
			],
		},
	];
};

export { Routes };
